/**
 * Canonical list of valid company accounting year-end dates.
 *
 * - `value`  — stored in MongoDB and sent to the API in MM-DD format.
 * - `label`  — human-friendly label shown in the UI selector.
 *
 * These are the only 12 values the backend's `_validate_company_year_end`
 * function accepts as real calendar month-ends. Keeping them here avoids
 * duplicating the list in every form that edits `company_year_end`.
 */
export const COMPANY_YEAR_END_OPTIONS = [
  { value: '01-31', label: '31 January' },
  { value: '02-28', label: '28 February' },
  { value: '03-31', label: '31 March' },
  { value: '04-30', label: '30 April' },
  { value: '05-31', label: '31 May' },
  { value: '06-30', label: '30 June' },
  { value: '07-31', label: '31 July' },
  { value: '08-31', label: '31 August' },
  { value: '09-30', label: '30 September' },
  { value: '10-31', label: '31 October' },
  { value: '11-30', label: '30 November' },
  { value: '12-31', label: '31 December' },
];

/**
 * Returns the canonical MM-DD value for a given raw string.
 * If the raw string is not one of the known options, returns '' (empty),
 * which the Select will render as the placeholder rather than crashing.
 *
 * @param {string | null | undefined} raw
 * @returns {string}
 */
export function normaliseYearEnd(raw) {
  if (!raw) return '';
  return COMPANY_YEAR_END_OPTIONS.some((o) => o.value === raw) ? raw : '';
}
